import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { uwinAPI } from "../../../services/uwin.api";
import { encryptText, getUwinClientToken } from "../../../helpers/common-uwinhelper.js";
import { safeDecrypt } from "./uwin-decrypt";

export const useBeneficiaryNavigation = (setIsPageLoading) => {
    const navigate = useNavigate();

    const navigateToDetails = async (item) => {
        try {
            if (setIsPageLoading) setIsPageLoading(true);

            const decryptedMobile = safeDecrypt(item.ben_mobile_number);
            if (!decryptedMobile || decryptedMobile === "-") {
                toast.error("Invalid mobile number.");
                if (setIsPageLoading) setIsPageLoading(false);
                return;
            }

            await getUwinClientToken();
            
            const response = await uwinAPI.getBeneficiaryProfile({
                beneficiary_id: item.beneficiary_id
            });

            if (response?.success && response?.data) {
                const beneficiary = response.data;

                let dob = beneficiary.dob || item.dob || "";
                let yearOfBirth = "";

                if (dob && dob.includes("-")) {
                    let parts = dob.split("-");
                    // Extract year regardless of DD-MM-YYYY or YYYY-MM-DD
                    if (parts[0].length === 4) {
                        yearOfBirth = parts[0];
                    } else if (parts[2].length === 4) {
                        yearOfBirth = parts[2];
                    } else {
                        // Fallback parsing
                        let [day, month, year] = parts;
                        let formattedDate = `${year}-${month}-${day}`;
                        let parsedYear = new Date(formattedDate).getFullYear();
                        if (!isNaN(parsedYear)) yearOfBirth = parsedYear.toString();
                    }
                }

                const gender = beneficiary.beneficiary_gender || item.beneficiary_gender || item.gender || "";

                const beneficiaryData = {
                    ...beneficiary,
                    name: beneficiary.ben_name || item.ben_name || "",
                    abhaNo: null,
                    originalabha: null,
                    address: "",
                    mobile: beneficiary.ben_mobile_number || item.ben_mobile_number,
                    dob: dob,
                    yearOfBirth: yearOfBirth ? "XX-XX-" + yearOfBirth : "",
                    gender: gender,
                    base64photo: null,
                    kycphoto: gender === "Female" ? "/images/female.svg" : "/images/male.svg",
                    profilePhoto: null,
                    preferredAbhaAddress: null,
                    email: null,
                    abhaNumber: null,
                    districtlgd: beneficiary.district_code || null,
                    statelgd: beneficiary.state_code || null,
                    mobileOriginal: beneficiary.ben_mobile_number || item.ben_mobile_number,
                };

                localStorage.setItem("beneficiaryDetails", JSON.stringify(beneficiaryData));
                localStorage.setItem("orignalBeneficiaryData", JSON.stringify(beneficiaryData));
                localStorage.removeItem("NCD_Searchdetails");
                localStorage.removeItem("NIKSHAY_Registration_Detials");
                localStorage.removeItem("NIKSHAY_NEW_PROFILE");
                navigate("/detailsabha");
            } else {
                toast.error(response?.message || "Could not fetch beneficiary details.");
            }
        } catch (error) {
            console.error("Error navigating to beneficiary details:", error);
            toast.error("Error navigating to beneficiary details.");
        } finally {
            if (setIsPageLoading) setIsPageLoading(false);
        }
    };

    return { navigateToDetails };
};
